import { SET_NOTES_REF } from "../../redux/constants";

const INITIAL_STATE = {
  NotesRef: {
    refId : "",
    noteTypeContext: ""
  },
};

export default function NotesRefReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_NOTES_REF:
      return {
        ...state,
        NotesRef: action.NotesRef,
      };
    default:
      return state;
  }
}

